<template>
	<v-card :width="width" color="siiAzul" class="rounded-lg" flat>
		<v-card-text>
			<v-card class="rounded-lg" elevation="5">
				<v-card-text>
					<slot name="body"></slot>
				</v-card-text>
			</v-card>

		</v-card-text>
	</v-card>
</template>

<script>
export default {
  name: 'PrimaryCard',
  props:{
  	width:{
  		default: '75%'
  	}
  },
  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
</style>